"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var disableInboxRuleService_1 = require("../services/disableInboxRuleService");
var enableInboxRuleService_1 = require("../services/enableInboxRuleService");
var store_1 = require("../store/store");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Enables / disables the given rule
 * @param inboxRuleId the inbox rule id
 * @param shouldBeEnabled whether the inbox rule should be enabled
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('enableDisableInboxRule', datapoints_1.default.enableDisableInboxRuleDatapoint)(function enableDisableInboxRule(inboxRuleId, shouldBeEnabled, state) {
    var optionState = state.optionState;
    var dataPoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var inboxRule = optionState.inboxRules.get(inboxRuleId);
    setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule);
    var enableDisableInboxRulePromise;
    if (inboxRule.Enabled) {
        enableDisableInboxRulePromise = enableInboxRuleService_1.default(inboxRule);
    }
    else {
        enableDisableInboxRulePromise = disableInboxRuleService_1.default(inboxRule);
    }
    // TODO: Proper error handling / success notification
    // Task 20143: Full error handling / success notification support
    return enableDisableInboxRulePromise
        .then(function (response) {
        if (!response.WasSuccessful) {
            setEnableDisableInboxRuleState(!shouldBeEnabled, inboxRule);
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        dataPoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
var setEnableDisableInboxRuleState = legacy_1.action('setEnableDisableInboxRuleState')(function setEnableDisableInboxRuleState(shouldBeEnabled, inboxRule) {
    inboxRule.Enabled = shouldBeEnabled;
});
//# sourceMappingURL=enableDisableInboxRule.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/enableDisableInboxRule.js
// module id = 5166
// module chunks = 2